import {z} from '@hono/zod-openapi';

import {advertisingMappingStatsRowSchema} from './AdvertisingMappingStatsRowSchema';
import {advertisingMappingStatsWindowSchema} from './AdvertisingMappingStatsWindowSchema';

export const advertisingMappingStatsResponseSchema = z
  .object({
    window: advertisingMappingStatsWindowSchema,
    from: z.string().datetime(),
    to: z.string().datetime(),
    rows: advertisingMappingStatsRowSchema.array(),
  })
  .openapi('AdvertisingMappingStatsResponse');

export type AdvertisingMappingStatsResponse = z.infer<typeof advertisingMappingStatsResponseSchema>;
